import { Form } from "antd"
import React from "react"
import { TextInput } from "../../../../../components/Input/TextInput.tsx"

interface SectionHeaderBlockProps {
  fieldKey: string
}

export function SectionHeaderBlock({ fieldKey }: SectionHeaderBlockProps) {
  return (
    <Form.Item
      name={["block_data", fieldKey, "title"]}
      label="Title"
      rules={[
        { required: true, whitespace: true, message: "Title is required" }
      ]}
    >
      <TextInput placeholder={"Enter title"} />
    </Form.Item>
  )
}
